import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

function ReCaptcha({ reCaptchaCodeHandler }) {
  return (
    <div>
      <ReCAPTCHA
        sitekey="6LfoejQqAAAAAAmLPBuoWiOYvCPejRRBy56zPqax"
        onChange={(value) =>
          setTimeout(() => {
            reCaptchaCodeHandler(value);
          }, 1000)
        }
      />
    </div>
  );
}

export default ReCaptcha;
